import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { TransportDetailsComponent } from './component/transport-details.component';
import { TransportDetailsFieldWrapperComponent } from './component/transport-details-field-wrapper/transport-details-field-wrapper.component';
import { TmcCommonFieldsModule } from '../fields/tmc-common-fields.module';



@NgModule({
  declarations: [
    TransportDetailsComponent,
    TransportDetailsFieldWrapperComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    TmcCommonFieldsModule
  ],
  exports: [
    TransportDetailsComponent
  ]
})
export class TransportDetailsModule { }
